import { useEffect, useState } from 'react'

import { safeName } from '@/utils/safeName'

export function useSafeName(
  prefix: string,
  values: readonly (string | null | undefined)[],
): string | null {
  const [name, setName] = useState<string | null>(null)
  const key = JSON.stringify([prefix, values])

  useEffect(() => {
    if (values.some((v) => v == null || v === '')) {
      setName(null)
      return
    }

    let cancelled = false
    safeName(prefix, values as string[])
      .then((n) => {
        if (!cancelled) setName(n)
      })
      .catch(() => {
        if (!cancelled) setName(null)
      })
    return () => {
      cancelled = true
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [key])

  return name
}
